<!-- <div class="content-area">
  <app-loading-animation></app-loading-animation>
  <router-outlet></router-outlet>
  <app-engage-nav-bar *ngIf="showEngageNavbar"></app-engage-nav-bar>
  <app-navbar *ngIf="!showEngageNavbar"></app-navbar>
</div>
<app-footer></app-footer> -->

<!-- <div class="app-container">
  <div class="content-area">
    <app-loading-animation></app-loading-animation>
    <router-outlet></router-outlet>
    <app-onboarding-nav-bar
      *ngIf="showOnboardingNavBar"
    ></app-onboarding-nav-bar>
    <app-engage-nav-bar *ngIf="showEngageNavbar"></app-engage-nav-bar>
    <app-navbar *ngIf="!showEngageNavbar && !showOnboardingNavBar"></app-navbar>
  </div>
  <app-footer></app-footer>
</div> -->

<!-- <div
  [ngClass]="{
    'layout expanded': !isNavbarCollapsed,
    'layout collapsed': isNavbarCollapsed
  }"
>
  <app-navbar
    (collapseChange)="onCollapseChange($event)"
    *ngIf="!showEngageNavbar && !showOnboardingNavBar"
  ></app-navbar>
  <div class="app-container">
    <app-loading-animation></app-loading-animation>
    <router-outlet></router-outlet>
    <!-- <app-navbar *ngIf="!showEngageNavbar && !showOnboardingNavBar"></app-navbar> -->
<!-- </div>
</div> -->

<div
  [ngClass]="{
    'layout expanded': !isNavbarCollapsed,
    'layout collapsed': isNavbarCollapsed
  }"
>
  <app-navbar (collapseChange)="onCollapseChange($event)"></app-navbar>
  <div class="app-container">
    <app-loading-animation></app-loading-animation>
    <router-outlet></router-outlet>
  </div>
</div>
